import { makePaymentDashboardPaymentButtonElem } from './constants'

export function paymentDashboardButtonDisable () {
  makePaymentDashboardPaymentButtonElem.prop('disabled', true)
  makePaymentDashboardPaymentButtonElem.css('pointer-events', 'none')
  makePaymentDashboardPaymentButtonElem.css('background-color', '#999999')
}

export function paymentDashboardButtonEnable () {
  makePaymentDashboardPaymentButtonElem.prop('disabled', false)
  makePaymentDashboardPaymentButtonElem.css('pointer-events', 'initial')
  makePaymentDashboardPaymentButtonElem.css('background-color', '#5cb85c')
}
